import { render, staticRenderFns } from "./LegalDocuments.vue?vue&type=template&id=144a7d69&scoped=true&"
import script from "./LegalDocuments.vue?vue&type=script&lang=js&"
export * from "./LegalDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144a7d69",
  null
  
)

export default component.exports